if (process.env.NODE_ENV && process.env.NODE_ENV === 'production') {
    (function(w,d, s, id) {if(typeof(w.webpushr)!=='undefined') return;w.webpushr=w.webpushr||function(){(w.webpushr.q=w.webpushr.q||[]).push(arguments)};var js, fjs = d.getElementsByTagName(s)[0];js = d.createElement(s); js.id = id;js.async=1;js.src = "https://cdn.webpushr.com/app.min.js";fjs.parentNode.appendChild(js);}(window,document, 'script', 'webpushr-jssdk'));
    window.webpushr('setup',{'key':'BPvRN9sxSh-m18fZdOCCh9BpBbTlyrlm7TTVuzAZ9k0uWc2Rs66YXT_6zvPMFdllKDSRyCk0yaYrPDzWS17nkcw' });
}else{

(function(w, d, s, id) {
    console.log('Looks like we are in development mode!');
    if (typeof (w.webpushr) !== 'undefined') return; w.webpushr = w.webpushr || function() { (w.webpushr.q = w.webpushr.q || []).push(arguments) }; var js, fjs = d.getElementsByTagName(s)[0]; js = d.createElement(s); js.id = id; js.async = 1; js.src = "https://cdn.webpushr.com/app.min.js";
    fjs.parentNode.appendChild(js);
}(window, document, 'script', 'webpushr-jssdk'));
window.webpushr('setup',
    { 'key': 'BGik_FfWgaEX38w_m6CMCw6lL7fyYeE0U5wmyqbpyhKAK8HUyVchhQlK4hlScKikmWctPDAQoBLskv1CcJ0MkEI', 'integration': 'popup' });
}
